/**
 * Version of the tour registry. It is recorded per user in
 * `vendor.properties.tourCompletions`: `version` when they finish or skip the
 * full tour, `featureTourVersion` when they finish or skip either tour (the
 * full tour covers every step, so it records both).
 *
 * Bump it when adding steps that users who already saw the tour must be
 * shown; steps added without a bump reach new users only.
 */
export const TOUR_VERSION = 1;
